import { httpClient } from '@/services/http/httpClient'

import type { IdeaField } from '../getFields'

type GenerateWithAIRequest = {
  challengeId: string
  name: string
  description: string
  fields: {
    id: string
    slug: string
    title: string
    description: string
    format: IdeaField['format']
    options: IdeaField['options']
    value: string
  }[]
}

type GenerateWithAIResponse = {
  name: string
  description: string
  fields: {
    id: string
    slug: string
    value: string
  }[]
}

export async function generateWithAI(
  body: GenerateWithAIRequest,
): Promise<GenerateWithAIResponse> {
  const { data } = await httpClient.post<GenerateWithAIResponse>(
    '/ideas/ai/generate-idea',
    body,
  )
  return data
}
